<template>
  <div>
    <section id="summary" class="container">
      <div class="segment box">
        <h1 class="title is-uppercase has-text-centered">Zone Entries</h1>
        <h2 class="subtitle is-uppercase has-text-centered">Even Handed Only</h2>
        <div class="small-box">
          <div class="columns">
            <div class="column is-half">
              <h2 class="subtitle has-text-centered">Controlled Zone Entries</h2>
              <chart width=100% type="bar" :options="apex_ze_player_options" :series="apex_ze_control_series" ref="apex_ze_control_chart"></chart>
            </div>
            <div class="column is-half">
              <h2 class="subtitle has-text-centered">Uncontrolled Zone Entries</h2>
              <chart width=100% type="bar" :options="apex_ze_player_options" :series="apex_ze_uncontrol_series" ref="apex_ze_uncontrol_chart"></chart>
            </div>
          </div>
          <div class="">
            <div class="">
              <div>
                <sort-table endpoint="https://devilsapi.roblutken.com/api/app/match-stats/zone-entries"
                :postData="[{
                team_id: 1,
                game_id: this.gameId
                }]"
                :selectedData="[
                    {
                      title: 'player',
                      prop: 'player'
                    },
                    {
                      title: 'Control Success',
                      prop: 'controlled_success'
                    },
                    {
                      title: 'Control Fail',
                      prop: 'controlled_failed'
                    },
                    {
                      title: 'Control Total',
                      prop: 'controlled_total'
                    },
                    {
                      title: 'Uncontroled Success',
                      prop: 'uncontrolled_success'
                    },
                    {
                      title: 'Uncontroled Fail',
                      prop: 'uncontrolled_failed'
                    },
                    {
                      title: 'Uncontroled Dump',
                      prop: 'uncontrolled_dump'
                    },
                    {
                      title: 'Uncontrolled Total',
                      prop: 'uncontrolled_total'
                    }
                ]"  @dataLoaded="gameDataLoaded"></sort-table>
              </div>
            </div>
          </div>
          <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <h2 class="subtitle has-text-centered">Team Uncontrolled %</h2>
            <chart width="100%" type="bar" :options="apex_ze_options" :series="apex_ze_series" ref="apex_ze_chart"></chart>
          </div>
        </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import SortTable from './sort-table'
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
export default {
  props: {
    period: { type: Number, required: true }
  },
  components: {
    SortTable,
    'chart': VueApexCharts
  },
  data () {
    return {
      gameId: 0,
      ZoneEntries: [],
      ZEPlayerVS: [],
      apex_ze_series: [
        {
          name: 'Uncontrolled %',
          data: []
        }
      ],
      apex_ze_options: {
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', height: 10, stacked: true },
        plotOptions: { bar: { horizontal: true } }
      },
      apex_ze_control_series: [
        {
          name: 'Successful Entry',
          data: []
        },
        {
          name: 'Unsucessful Entry',
          data: []
        }
      ],
      apex_ze_uncontrol_series: [
        {
          name: 'Successful Entry',
          data: []
        },
        {
          name: 'Unsucessful Entry',
          data: []
        }
      ],
      apex_ze_player_options: {
        colors: ['#8b0505d1', '#000000'],
        chart: { type: 'bar', height: 900, stacked: true },
        plotOptions: { bar: { horizontal: true } }
      }
    }
  },
  computed: {

  },
  watch: {
    endpoint: {
      handler: function (endpoint) {
        this.url = endpoint
      },
      immediate: true
    },
    gameId: {
      handler: function (postData) {
        // console.log('Post data updated: ' + JSON.stringify(this.postData))
        this.fetchZoneEntries()
      },
      immediate: true
    }
  },
  methods: {
    gameDataLoaded () {
      console.log('Loaded')
    },
    fetchZoneEntries () {
      let postData = {
        'game_id': this.gameId,
        'situation': 0
      }
      this.$http.post('https://devilsapi.roblutken.com/api/app/match-stats/team-zone-entries', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(response => {
        this.ZoneEntries = response.data
        this.apex_ze_series[0].data = []
        this.apex_ze_series[0].data.push(this.ZoneEntries.uncontrolled_percentage)
        let cats = ['Uncontrolled %']
        let newOptions = { xaxis: { categories: cats, max: 100 } }
        this.$refs.apex_ze_chart.updateOptions(newOptions)
      })
    },
    fetchZoneEntriesGraph () {
      let postData = {
        'game_id': this.gameId,
        'situation': 0
      }
      let zoneEntryPlayersC = []
      let zoneEntryPlayersU = []
      this.$http.post('https://devilsapi.roblutken.com/api/app/match-stats/zone-entries-graph', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(response => {
        this.ZEPlayerVS = response.data
        let zeS = _.orderBy(this.ZEPlayerVS, function (ze) {
          return (ze.control_success + ze.control_failure)
        }, ['desc'])
        let zeF = _.orderBy(this.ZEPlayerVS, function (ze) {
          return (ze.uncontrol_success + ze.uncontrol_failure)
        }, ['desc'])
        for (var ze of zeS) {
          // this.apex_ze_uncontrol_series[0].data.push(ze.uncontrol_success)
          // this.apex_ze_uncontrol_series[1].data.push(-ze.uncontrol_failure)
          if ((ze.control_failure + ze.control_success) > 0) {
            zoneEntryPlayersC.push(ze.player)
            this.apex_ze_control_series[0].data.push(ze.control_success)
            this.apex_ze_control_series[1].data.push(-ze.control_failure)
          }
        }
        for (var zeU of zeF) {
          // this.apex_ze_uncontrol_series[0].data.push(ze.uncontrol_success)
          // this.apex_ze_uncontrol_series[1].data.push(-ze.uncontrol_failure)
          if ((zeU.uncontrol_success + zeU.uncontrol_failure) > 0) {
            zoneEntryPlayersU.push(zeU.player)
            this.apex_ze_uncontrol_series[0].data.push(zeU.uncontrol_success)
            this.apex_ze_uncontrol_series[1].data.push(-zeU.uncontrol_failure)
          }
        }
        let newOptions = { xaxis: { categories: zoneEntryPlayersC } }
        this.$refs.apex_ze_control_chart.updateOptions(newOptions)
        let zeUncontrolledOpts = { xaxis: { categories: zoneEntryPlayersU } }
        this.$refs.apex_ze_uncontrol_chart.updateOptions(zeUncontrolledOpts)
        console.log('Players for Zone Entries: ' + JSON.stringify(newOptions))
      })
    },
    resetData () {
      let newOptions = { xaxis: { categories: [] } }
      this.$refs.apex_ze_chart.updateOptions(newOptions)
      this.$refs.apex_ze_control_chart.updateOptions(newOptions)
      this.$refs.apex_ze_uncontrol_chart.updateOptions(newOptions)
      this.apex_ze_control_series[0].data = []
      this.apex_ze_control_series[1].data = []
      this.apex_ze_uncontrol_series[0].data = []
      this.apex_ze_uncontrol_series[1].data = []
      this.apex_ze_series[0].data = []
    }
  },
  mounted: function () {
    // console.log('Fetch ZoneEntries: ' + this.gameId)
    this.gameId = this.$route.params.gameId
    this.resetData()
    this.fetchZoneEntries()
    this.fetchZoneEntriesGraph()
  }
}
</script>
<style lang='scss' scoped>
.segment {
  padding-top: 1em;
  padding-bottom: 2em;
  margin-right: auto;
  margin-left: auto;
  max-width: 98%;
  margin-top: 1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow: -2px -1px 10px 3px rgba(112, 111, 112, .2);
  -moz-box-shadow: -2px -1px 10px 3px rgba(112, 111, 112, .2);
  box-shadow: -2px -1px 10px 3px rgba(112, 111, 112, .2);
}

.small-box {
  padding-top: 1em;
  padding-bottom: 2em;
  margin-right: auto;
  margin-left: auto;
  max-width: 100%;
  margin-top: 1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow: -2px -1px 10px 3px rgba(112, 111, 112, .2);
  -moz-box-shadow: -2px -1px 10px 3px rgba(112, 111, 112, .2);
  box-shadow: -2px -1px 10px 3px rgba(112, 111, 112, .2);
}

.segment h1 {
  color: black;
  text-shadow: 0px 1px 1px #8b0505d1;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}

.segment h2 {
  color: rgb(39, 39, 39);
  margin-top: 0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}

.segment p {
  font-size: 1.2em;
  text-transform: uppercase;
}

.stat-title {
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color: rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}

.stat-category {
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color: rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}

.stat-number {
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color: black;
}
</style>



// WEBPACK FOOTER //
// match-zone-entries.vue?38312de9